import { render, staticRenderFns } from "./SponsorLogo.vue?vue&type=template&id=485260b6&scoped=true&"
import script from "./SponsorLogo.vue?vue&type=script&lang=js&"
export * from "./SponsorLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485260b6",
  null
  
)

export default component.exports